import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/education/research")({
  component: ResearchLayout,
});

function ResearchLayout() {
  return <Outlet />;
}